import { render, staticRenderFns } from "./right.vue?vue&type=template&id=5e583166&scoped=true&"
import script from "./right.vue?vue&type=script&lang=js&"
export * from "./right.vue?vue&type=script&lang=js&"
import style0 from "./right.vue?vue&type=style&index=0&id=5e583166&lang=scss&scoped=true&"
import style1 from "./right.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e583166",
  null
  
)

export default component.exports